export default __webpack_public_path__ + "static/media/b_boletin_cooperando_small.9c7ebc67.jpg";